export default function setClampText() {
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-clamp-text-expand]');
        if (!btn) return;

        const text = btn.parentElement.querySelector('[data-clamp-text]');
        const expanded = text.dataset.expanded === 'true';

        if (expanded) {
            text.classList.add('line-clamp-2');
            text.dataset.expanded = 'false';
            btn.textContent = 'Rozwiń';
        } else {
            text.classList.remove('line-clamp-2');
            text.dataset.expanded = 'true';
            btn.textContent = 'Zwiń';
        }
    });
}